module.exports = __webpack_public_path__ + "img/nbsupply.77c58936.jpg";